import React, { useEffect, useState } from 'react';
import gsap from 'gsap';
import '../modal.css';
const ProgressBarComponent = ({ loadingMessage }: any) => {
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const progressBar = document.querySelector('.progress-bar');
        if (progressBar) {
            let targetValue = 95;
            setProgress(targetValue);
            gsap.to(progressBar, {
                x: `${progress}%`,
                duration: 8,
                onComplete: () => {

                },
            });
        }
    }, [progress]);

    return (

        <div className="connectWindowContainer">
            <div className="connectWindow loading01">
                <div className="scan-text">
                    <div className="progress-bar__container">
                        <div className="progress-bar__text">{loadingMessage}</div>
                        <div className="progress-bar"></div>
                    </div>
                </div>
            <div className="rantCPU_01"></div>
            </div>
        </div>


    );
};
export default ProgressBarComponent;
